import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { initialAutomobileInsuranceLapseState } from "./automobileInsuranceLapse.types";
import { AutomobileInsuranceLapseAction } from ".";
import {
  CLEAR_AUTOMOBILE_INSURANCE_LAPSE_INFO,
  FETCH_AUTOMOBILE_INSURANCE_LAPSE_FAILED,
  FETCH_AUTOMOBILE_INSURANCE_LAPSE_LIST_FAILED,
  FETCH_AUTOMOBILE_INSURANCE_LAPSE_LIST_PROGRESS,
  FETCH_AUTOMOBILE_INSURANCE_LAPSE_LIST_SUCCESS,
  FETCH_AUTOMOBILE_INSURANCE_LAPSE_PROGRESS,
  FETCH_AUTOMOBILE_INSURANCE_LAPSE_SUCCESS,
} from "./automobileInsuranceLapseActions";

export const AutomobileInsuranceLapseReducer = (
  state: IStoreState["automobile"]["insuranceLapse"] = initialAutomobileInsuranceLapseState,
  action: AutomobileInsuranceLapseAction
) => {
  switch (action.type) {
    case FETCH_AUTOMOBILE_INSURANCE_LAPSE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_INSURANCE_LAPSE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_INSURANCE_LAPSE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage;
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_INSURANCE_LAPSE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_INSURANCE_LAPSE_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }
    case FETCH_AUTOMOBILE_INSURANCE_LAPSE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
      });
      return newState;
    }

    case CLEAR_AUTOMOBILE_INSURANCE_LAPSE_INFO: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.data = initialAutomobileInsuranceLapseState["data"];
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
